import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";
import type { Playlist, PlaylistAnalyticsResponse } from "../types";
export function usePlaylistAnalytics(days, options) {
  const $ = _c(9);
  const apiFetcher = useApiFetcher();
  const queryParams = days != null ? `?days=${days}` : "";
  let t0;
  if ($[0] !== days) {
    t0 = [...QUERY_KEYS.playlistAnalytics(days ?? 30)];
    $[0] = days;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== apiFetcher || $[3] !== queryParams) {
    t1 = () => apiFetcher(`/api/v1/playlists/analytics${queryParams}`);
    $[2] = apiFetcher;
    $[3] = queryParams;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== options || $[6] !== t0 || $[7] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      staleTime: 30000,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      ...options
    };
    $[5] = options;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return useQuery(t2);
}
export function usePlaylist(playlistId) {
  const $ = _c(9);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] !== playlistId) {
    t0 = [...QUERY_KEYS.playlist(playlistId ?? "")];
    $[0] = playlistId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== apiFetcher || $[3] !== playlistId) {
    t1 = () => apiFetcher(`/api/v1/playlists/${playlistId}`);
    $[2] = apiFetcher;
    $[3] = playlistId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = !!playlistId;
  let t3;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      staleTime: 300000
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useQuery(t3);
}
export function usePlaylistBadges() {
  const $ = _c(2);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] !== apiFetcher) {
    t0 = {
      queryKey: QUERY_KEYS.PLAYLIST_BADGES,
      queryFn: async () => {
        const analytics = await apiFetcher("/api/v1/playlists/analytics?days=30");
        return analytics.badges;
      },
      staleTime: 600000,
      refetchInterval: 1800000
    };
    $[0] = apiFetcher;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
}